import { usePermissions } from "../../../context/PermissionsContext";
import { BOUNCER_PERMISSIONS } from "../../../constants/bouncerPermissions";
import { PERMISSIONS } from "../constants/permissions";

/**
 * Resolves the approval-level string returned by getApprovalPayload/getRejectPayload
 * (vm_approval / l1_approval / l2_approval) to whether the logged-in user holds the
 * matching Bouncer permission.
 *
 * Shared by InvoiceDetails.js and InvoiceReview.js so a future tier change is made
 * in one place. Bouncer permissions are fetched once at login and read from context.
 */
export function useApprovalMapping() {
  const { hasPermission } = usePermissions();
  const canVmApproval = hasPermission(BOUNCER_PERMISSIONS.INVOICE_VM_APPROVAL);
  const canL1Approval = hasPermission(BOUNCER_PERMISSIONS.INVOICE_L1_APPROVAL);
  const canL2Approval = hasPermission(BOUNCER_PERMISSIONS.INVOICE_L2_APPROVAL);

  const approvalMapping = (permission) => {
    if (permission === PERMISSIONS.l1_approval) return canL1Approval;
    if (permission === PERMISSIONS.l2_approval) return canL2Approval;
    if (permission === PERMISSIONS.vm_approval) return canVmApproval;
    return false;
  };

  return { approvalMapping, canVmApproval, canL1Approval, canL2Approval };
}
